import { render } from "./application_history.vue?vue&type=template&id=bf52d9f6"
import script from "./application_history.vue?vue&type=script&lang=js"
export * from "./application_history.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/host/imc/tender/dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vue/js/components/sale/applications/inside/history/application_history.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "bf52d9f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bf52d9f6', __exports__)) {
    console.log('reload')
    api.reload('bf52d9f6', __exports__)
  }
  
  module.hot.accept("./application_history.vue?vue&type=template&id=bf52d9f6", () => {
    console.log('re-render')
    api.rerender('bf52d9f6', render)
  })

}


export default __exports__